import axiosPublicClient from "../../../../axiosPublicClient"

export default async (responseKey) => {
    const result = await axiosPublicClient.post('/pre-adverse-action-response-context', {
        responseKey,
    })
    return result.data
}
